<template>
  <el-container>
   <el-header slot="header" class="clearfix">
    <span>{{ $t('route.elementoedit') }}</span>
   </el-header>
   <el-main>
     <el-form>
   <span>{{ $t('elemento.description')}}</span>
   <el-input name="descripcion" v-model="elemento.elhi_descripcion"></el-input>
   <p/>
   <span>{{ $t('elemento.code')}}</span>
   <el-input v-maska="'######'" ref="codigo" name="codigo" v-model="elemento.elhi_codigo" @blur="validarCodigo()" style="width:150px;"></el-input>
   <span>{{ $t('elemento.type')}}</span>
   <el-select v-model="elemento.tiel_id" name="tipo" :placeholder="$t('tipoelemento.select')">
      <el-option v-for="tipoelemento in tiposElemento" :key="tipoelemento.tiel_id" :label="tipoelemento.tiel_descripcion" :value="tipoelemento.tiel_id" >
      </el-option>
   </el-select>
   <p/>
   <span>{{ $t('elemento.unitario')}}</span>
   <el-select v-model="elemento.unitarios" name="unitario" multiple :placeholder="$t('unitario.select')">
      <el-option v-for="u in unitarios" :key="u.unit_id" :label="u.unit_codigo + '-' + u.unit_descripcion" :value="u.unit_id" >
      </el-option>
   </el-select>
   <p/>
   <el-button :disabled="!validate()" size="medium" type="primary" icon="el-icon-check" @click="aplicar"></el-button>
     </el-form>
   </el-main>
  </el-container>
</template>
<script>
import { getElementoByCode, saveElemento } from '@/api/ordentrabajo_historico'
import { getTiposElemento } from '@/api/tipoelemento'
import { getCaracteristicas } from '@/api/caracteristica'
import { getUcapsTodas } from '@/api/ucap'
import { getUnitariosTodas } from '@/api/unitario'

export default {
name: 'CrearElementoHistorico',
data () {
  return {
    elemento: {
      elhi_descripcion: null,
      elhi_codigo: null,
      elhi_estado: 1,
      tiel_id: null,
      empr_id: 0,
      usua_id: 0,
      ucap_id: null,
      unitarios: []
    },
    elemento_caracteristica: {
      elhi_id: 0,
      cara_id: null,
      cara_descripcion: null,
      elca_valor: null,
      elca_estado: 1
    },
    unitario: {
      unit_id: null,
      unit_codigo: null,
      unit_descripcion: null,
      empr_id: null
    },
    tiposElemento: [],
    caracteristicas: [],
    ucaps: [],
    valores: [],
    checkedCaracteristicas: [],
    unitarios: [],
    isIndeterminate: false,
    checkAll: false,
    message: '',
    loading: false,
    page_size: 10,
    current_page: 1,
    total: 0,
    noexiste: false
  }
},
methods: {
  validarCodigo () {
    let codigo = this.elemento.elhi_codigo
    codigo = '000000' + codigo
    codigo = codigo.substr(codigo.length - 6)
    this.elemento.elhi_codigo = codigo
    getElementoByCode(this.elemento.elhi_codigo).then(response => {
      const elemento = response.data
      this.$notify({
        title: 'Material código ' + elemento.elhi_codigo + ' ya existe',
        message: elemento.elhi_descripcion,
        type: 'warning'
      })
      this.noexiste = false
      this.elemento.elhi_codigo = ''
      this.$refs.codigo.focus()
    }).catch(() => {
      this.noexiste = true
    })
  },
  aplicar () {
    var e = Object.assign({}, this.elemento)
    var unitarios = []
    this.elemento.unitarios.forEach(u => {
      unitarios.push({ unit_id: u })
    })
    e.unitarios = unitarios
    saveElemento(e).then(response => {
      if (response.status === 200) {
        if (response.data === 0) {
          this.error('No Creado')
        } else {
          this.success()
        }
      }
    }).catch(error => {
      this.error(error)
    })
  },
  validate () {
    if (this.noexiste && this.elemento.elhi_descripcion && this.elemento.elhi_codigo && this.elemento.tiel_id > 0) {
      return true
    } else {
      return false
    }
  },
  limpiarAndBack () {
    this.elemento = {
      elhi_descripcion: null,
      elhi_codigo: null,
      elhi_estado: 1,
      tiel_id: null,
      empr_id: 0,
      usua_id: 0,
      ucap_id: null,
      unitarios: []
    }
    this.$router.push({ path: '/administracion/elemento' })
  },
  limpiar () {
    this.elemento = {
      elhi_descripcion: '',
      elhi_codigo: '',
      elhi_estado: 1,
      tiel_id: '',
      empr_id: 0,
      usua_id: 0,
      unitarios: []
    }
  },
  success () {
    this.$notify({
      title: this.$i18n.t('elemento.success'),
      message: this.$i18n.t('elemento.created') + ' ' + this.elemento.elhi_descripcion,
      type: 'success',
      onClose: this.limpiar()
    })
  },
  error (e) {
    this.$notify.error({
      title: this.$i18n.t('elemento.error'),
      message: this.$i18n.t('elemento.notcreated') + ' ' + e,
      onClose: this.limpiar()
    })
  },
  onAddCharacteristic () {
    this.elemento.caracteristicas.push(this.elemento_caracteristica)
    this.elemento_caracteristica = {
      elhi_id: 0,
      cara_id: null,
      cara_descripcion: null,
      elca_valor: null
    }
  },
  handleChangeCharacteristic () {
    if (this.elemento_caracteristica.cara_id === null) {
      this.valores = []
    } else {
      this.valores = this.caracteristicas.find(o => o.cara_id === this.elemento_caracteristica.cara_id).cara_valores.split(',')
    }
  },
  handleSizeChange (val) {
    this.page_size = val
  },
  handleCurrentChange (val) {
    this.current_page = val
  },
  handleDelete (index, row) {
    this.elemento.caracteristicas.splice(index, 1)
  },
  caracteristica (cara_id) {
    if (cara_id === null) {
      return ''
    } else {
      return this.caracteristicas.find(o => o.cara_id === cara_id, '').cara_descripcion
    }
  },
  getTipos () {
    getTiposElemento().then(response => {
      this.tiposElemento = response.data
    }).catch(() => {})
  },
  getCaracteristicas () {
    getCaracteristicas().then(response => {
      this.caracteristicas = response.data
    }).catch(() => {})
  },
  getUcaps () {
    getUcapsTodas().then(response => {
      this.ucaps = response.data
    }).catch(() => {})
  },
  getUnitarios () {
    getUnitariosTodas().then(response => {
      this.unitarios = response.data
    }).catch(() => {})
  },
  handleCheckAllChange (val) {
    this.checkedCaracteristicas = val ? this.caracteristicas : []
    this.isIndeterminate = false
  },
  handleCheckedCaracteristicasChange (value) {
    const checkedCount = value.length
    this.checkAll = checkedCount === this.caracteristicas.length
    this.isIndeterminate = checkedCount > 0 && checkedCount < this.caracteristicas.length
  }
},
mounted () {
  this.getTipos()
  this.getCaracteristicas()
  this.getUcaps()
  this.getUnitarios()
}
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.box-card {
width: 480px;
}
.footfont {
font-size: 11px;
}
</style>
